<template>
<span class="wrapper" :class="{'flex-end':$store.state.session.user.UserID === message.From}">
  <div class="" :class="{'messageBalloonMainReverse':$store.state.session.user.UserID === message.From,'messageBalloonMain':$store.state.session.user.UserID !== message.From}">
    <!-- <div class="spacer" v-if="$store.state.session.user.UserID === message.From" /> -->
    <div :class="{
      speechBubbleTailedLeft:
        $store.state.session.user.UserID !== message.From &&
        !message.continueFromSameBuddy,
      speechBubbleNonTailedLeft:
        $store.state.session.user.UserID !== message.From &&
        message.continueFromSameBuddy,
      speechBubbleTailedRight:
        $store.state.session.user.UserID === message.From &&
        !message.continueFromSameBuddy,
      speechBubbleNonTailedRight:
        $store.state.session.user.UserID === message.From &&
        message.continueFromSameBuddy
    }"
    >
      <ForwardedMessageRow v-if="message.isForwarded" />
      <RepliedMessageRow v-if="message.ReplyMessage" :message="message.ReplyMessage" />

      <div class="senderName" :style="{ color: userColor(message.From) }" v-if="
        message.isGroup === true &&
          $store.state.session.user.UserID !== message.From &&
          !message.continueFromSameBuddy
      "
      >
        {{ getUserNameDisplay(message.From) }}
      </div>

      <img
        v-if="message.MediaURLs && message.MediaURLs.length"
        :src="getMimeImage(message.MediaURLs[0])"
        @click="openDocument(message.MediaURLs[0])"
        class="imageMessage"
      >
      <div class="messageTextContainer">
        {{ message.Body }}
      </div>

      <ReactionPicker :visible="showReactionPicker" @select="onToggleReaction" @close="closeReactionPicker" />
      <MessageMenuDropDown :message="message" @open-reactions="openReactionPicker" />

      <MessageBalloonInfoRow :message="message" />
    </div>

    <MessageReactions :reactions="message.Reactions" :message="message" @toggle-reaction="onToggleReaction" @open-picker="openReactionPicker" />

    <img class="forwardButton" src="/images/forward.png" v-if="$store.state.session.user.UserID !== message.From && message.MessageType !== 0" @click="forwardMsg">

    <div class="spacer" v-if="$store.state.session.user.UserID !== message.From" />
  </div>
  </span>
</template>

<script>
import ForwardedMessageRow from './common/ForwardedMessageRow.vue'
import RepliedMessageRow from './common/RepliedMessageRow.vue'
import MessageBalloonInfoRow from './common/MessageBalloonInfoRow.vue'
import MessageMenuDropDown from './common/MessageMenuDropDown.vue'
import MessageReactions from './common/MessageReactions.vue'
import ReactionPicker from './common/ReactionPicker.vue'
import {
  messageMixin
} from '@/mixins/messageMixin.js'
export default {
  components: {
    ForwardedMessageRow,
    RepliedMessageRow,
    MessageBalloonInfoRow,
    MessageMenuDropDown,
    MessageReactions,
    ReactionPicker
  },

  mixins: [messageMixin],

  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      showReactionPicker: false
    }
  },

  methods: {
    onToggleReaction (emoji) {
      this.toggleReaction(this.message, emoji)
      this.showReactionPicker = false
    },
    openReactionPicker () {
      this.showReactionPicker = true
    },
    closeReactionPicker () {
      this.showReactionPicker = false
    },
    getMimeImage (documentURL) {
      let documentExtension = documentURL.split('.').pop()
      return '/images/mimes/' + documentExtension + '.png'
    },

    openDocument (url) {
      var vm = this
      if (vm.message.mv <= 1) {
        window.open(url, url)
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key.split('').reverse().join('')
        let encryptedBody = vm.ewk(url, key, iv)
        window.open(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + url + '&s=' + encodeURIComponent(encryptedBody), url)
      }
    },

    forwardMsg () {
      let messageToForward = this.message
      this.$store.commit('setMessageToForward', messageToForward)

      this.$store.state.display.modal.viewState = 'forwardMessage'
      this.$modal.show('homepage')
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../../../../style/messageBalloon";

  .imageMessage {
    width: 80px;
    cursor: pointer;
  }

</style>
